import queryString from 'query-string';
import { MINERVA_API_URL, BEST_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchMyCards({ dispatch }, filters) {
  const queryParams = queryString.stringify(filters);

  return http.get(`${MINERVA_API_URL}/cards?${queryParams}`)
    .then((res) => {
      if (filters.offset === 0) {
        return dispatch('setMyCardsInStore', res.data);
      }

      return dispatch('addMyCardsInStore', res.data);
    })
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching my cards:', err);
      return Promise.reject(err);
    });
}

export function fetchMyCardDetails({ dispatch }, cardId) {
  return http.get(`${MINERVA_API_URL}/cards/${cardId}`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching my card details:', err);
      return Promise.reject(err);
    });
}

export function fetchMyCardPages({ dispatch }, { cardId, isPublisherUser = false }) {
  const params = isPublisherUser ? { is_publisher: true } : {};
  return http.get(`${MINERVA_API_URL}/cards/${cardId}/pages`, { params })
    .then(res => (
      dispatch('setMyCardPages', { cardId, pageList: res.data })
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching my card pages:', err);
      return Promise.reject(err);
    });
}

export function createNewMyCard({ dispatch }, newCard) {
  return http.post(`${MINERVA_API_URL}/cards`, newCard)
    .then(res => (
      dispatch('addMyCardsInStore', [res.data])
        .then(() => (res.data))
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while creating new assignment:', err);
      return Promise.reject(err);
    });
}

export function updateMyCard({ dispatch }, { cardId, updateInfo }) {
  return http.patch(`${MINERVA_API_URL}/cards/${cardId}`, updateInfo)
    .catch((err) => {
      // TODO: handle error
      console.error('err while updating my card:', err);
      return Promise.reject(err);
    });
}

export function removeMyCard({ dispatch }, cardId) {
  return http.delete(`${MINERVA_API_URL}/cards/${cardId}`)
    .then(() => (
      dispatch('removeMyCardInStore', cardId)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while removing my card:', err);
      return Promise.reject(err);
    });
}

export function uploadNewCardCoverImage({ dispatch }, { cardId, imageFile }) {
  const formData = new FormData();
  formData.append('file', imageFile);

  return http.post(`${MINERVA_API_URL}/cards/${cardId}/cover_images`, formData)
    .then(res => (
      dispatch('setMyCardCoverImage', { cardId, coverImage: res.data.file_url })
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while uploading new cover image:', err);
      return Promise.reject(err);
    });
}

export function removeMyCardCoverImage({ dispatch }, cardId) {
  return http.delete(`${MINERVA_API_URL}/cards/${cardId}/cover_images`)
    .then(() => (
      dispatch('setMyCardCoverImage', { cardId, coverImage: '' })
    ))
    .catch((err) => {
      const res = err.response;

      // silently omit error when resource not found
      if (res && res.status === 404) {
        return err;
      }

      // TODO: handle error
      console.error('err while removing card cover image:', err);
      return Promise.reject(err);
    });
}

export function createNewMyCardPage({ dispatch }, { cardId, page }) {
  return http.post(`${MINERVA_API_URL}/cards/${cardId}/pages`, page)
    .then(res => (res.data))
    .catch((err) => {
      // TODO: handle error
      console.error('err while creating new my card page:', err);
      return Promise.reject(err);
    });
}

export function updateMyCardPages({ dispatch }, { cardId, pageUpdateList }) {
  return http.patch(`${MINERVA_API_URL}/cards/${cardId}/pages`, pageUpdateList)
    .catch((err) => {
      // TODO: handle error
      console.error('err while updating my card pages:', err);
      return Promise.reject(err);
    });
}

export function updateMyPage({ dispatch }, { pageId, updateInfo }) {
  return http.patch(`${MINERVA_API_URL}/pages/${pageId}`, updateInfo)
    .then(res => (res.data))
    .catch((err) => {
      // TODO: handle error
      console.error('err while updating my page:', err);
      return Promise.reject(err);
    });
}

export function uploadNewCardPageImage({ dispatch }, { pageId, imageFile }) {
  const formData = new FormData();
  formData.append('file', imageFile);

  return http.post(`${MINERVA_API_URL}/pages/${pageId}/images`, formData)
    .then(res => (res.data))
    .catch((err) => {
      // TODO: handle error
      console.error('err while uploading new page image:', err);
      return Promise.reject(err);
    });
}

export function uploadNewCardPageAudio(_, { pageId, audioFile }) {
  const formData = new FormData();
  formData.append('file', audioFile);

  return http.post(`${MINERVA_API_URL}/pages/${pageId}/audios`, formData)
    .then(res => (res.data))
    .catch((err) => {
      // TODO: handle error
      console.error('err while uploading new page audio:', err);
      return Promise.reject(err);
    });
}

export function removeMyCardPageImage({ dispatch }, imageId) {
  return http.delete(`${MINERVA_API_URL}/images/${imageId}`)
    .then(res => (res.data))
    .catch((err) => {
      // TODO: handle error
      console.error('err while removing page image:', err);
      return Promise.reject(err);
    });
}

export function removeMyCardPageAudio(_, audioId) {
  return http.delete(`${MINERVA_API_URL}/audios/${audioId}`)
    .then(res => (res.data))
    .catch((err) => {
      // TODO: handle error
      console.error('err while removing page audio:', err);
      return Promise.reject(err);
    });
}

export function fetchVideoEmbedSrc(_, params) {
  return http.get(`${MINERVA_API_URL}/video-embed-src`, { params })
    .then(res => (res.data))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching video embed src:', err);
      return Promise.reject(err);
    });
}

export function exportToBest(_, card) {
  return http.post(`${BEST_URL}/sync`, card)
    .then(res => (res.data))
    .catch((err) => {
      console.error('err while sync content:', err);
      return Promise.reject(err);
    });
}

export function setMyCardsInStore({ commit }, cardList) {
  commit(types.SET_CARDS, cardList);

  return Promise.resolve(cardList);
}

export function addMyCardsInStore({ commit }, cardList) {
  commit(types.ADD_CARDS, cardList);

  return Promise.resolve(cardList);
}

export function updateMyCardInStore({ commit }, updatedCard) {
  commit(types.UPDATE_CARD, updatedCard);

  return Promise.resolve();
}

export function makeMyCardPrivateInStore({ commit }, cardId) {
  commit(types.MAKE_CARD_PRIVATE, cardId);

  return Promise.resolve();
}

export function makeMyCardPublicInStore({ commit }, cardId) {
  commit(types.MAKE_CARD_PUBLIC, cardId);

  return Promise.resolve();
}

export function setMyCardShareLevel({ commit }, { cardId, shareLevel }) {
  commit(types.SET_CARD_SHARE_LEVEL, { cardId, shareLevel });

  return Promise.resolve();
}

export function removeMyCardInStore({ commit }, cardId) {
  commit(types.REMOVE_CARD, cardId);

  return Promise.resolve();
}

export function setMyCardPages({ commit }, setInfo) {
  commit(types.SET_CARD_PAGES, setInfo);

  return Promise.resolve(setInfo.pageList);
}

export function setMyCardCoverImage({ commit }, setInfo) {
  commit(types.SET_CARD_COVER_IMAGE, setInfo);

  return Promise.resolve(setInfo.coverImage);
}

export function addSelectedPage({ commit }, page) {
  commit(types.ADD_SELECTED_PAGE, page);

  return Promise.resolve();
}

export function removeSelectedPage({ commit, getters }, pageId) {
  const index = getters.selectedPageIds.indexOf(pageId);
  commit(types.REMOVE_SELECTED_PAGE, index);

  return Promise.resolve();
}

export function resetSelectedPage({ commit }) {
  commit(types.RESET_SELECTED_PAGE);

  return Promise.resolve();
}



// WEBPACK FOOTER //
// ./src/app/my-cards/store/actions.js